import axios from 'axios';

export const getApiKeys = async () => {
    const { data } = await axios.get('/api/api-keys');
    return data;
};

export const getApiKeyCapabilities = async () => {
    const { data } = await axios.get('/api/api-keys/capabilities');
    return Array.isArray(data?.capabilities) ? data.capabilities : [];
};

export const createApiKey = async ({ name, description, rateLimitPerMinute } = {}) => {
    const payload = { name, description, rateLimitPerMinute };
    const { data } = await axios.post('/api/api-keys', payload);
    return data;
};

export const rotateApiKey = async ({ id, name, description, rateLimitPerMinute } = {}) => {
    if (!id) {
        throw new Error('id is required');
    }
    const payload = { name, description, rateLimitPerMinute };
    const { data } = await axios.post(`/api/api-keys/${encodeURIComponent(id)}/rotate`, payload);
    return data;
};

export const updateApiKey = async ({ id, ...updates } = {}) => {
    if (!id) {
        throw new Error('id is required');
    }
    const { data } = await axios.patch(`/api/api-keys/${encodeURIComponent(id)}`, updates);
    return data;
};

export const createOAuthClientForApiKey = async ({ id, redirectUri, clientName } = {}) => {
    if (!id) {
        throw new Error('id is required');
    }
    const payload = { redirectUri, clientName };
    const { data } = await axios.post(`/api/api-keys/${encodeURIComponent(id)}/oauth-clients`, payload);
    return data;
};
